import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BaseComponent } from '@wms/components';
import { WmsMessageComponent } from '../wms-message/wms-message.component';
import { WmsSpinnerComponent } from '../wms-spinner/wms-spinner.component';
import { WmsTreeComponent } from '../wms-tree/wms-tree.component';
import { WmsTypeaheadComponent } from '../wms-typeahead/wms-typeahead.component';

import {BaseVariableService, VARIABLE_CONSTANTS} from '@wms/variables';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BindVariableService, EmbedDbService, TypeFactoryService } from "@wms/services";
import {WmsFeatureDirective} from "@wms/directives";
import {includes} from "lodash-es";
import {Router} from "@angular/router";
import {PageWsService, WmsWorkspaceManagerService} from "@wms/workspace";
import {byType} from "@wms/core";

@Component({
  selector: 'wms-select-data-source',
  standalone: true,
  templateUrl: './select-data-source.component.html',
  styleUrls: ['./select-data-source.component.less'],
  imports: [
    CommonModule,
    WmsMessageComponent,
    WmsSpinnerComponent,
    WmsTreeComponent,
    WmsTypeaheadComponent,
    WmsFeatureDirective,
    FormsModule,
    TooltipModule
  ],
  host: {class: 'wms-wizard-body-content'}
})
export class SelectDataSourceComponent extends BaseComponent {
  @Input() variableFilter!: any;
  @Input() metadataFilter!: any;
  @Input() metadataVariableList!: any;
  @Input() widgetFilter!: any;
  @Input() dataSource!: any;
  @Input() filteredDataSources!: any;
  @Input() selectedDataSource!: any;
  @Input() widgetType!: any;
  @Input() widgetDetails!: any;
  @Input() widgetConfig!: any;
  @Input() isSourceMode!: any;
  @Input() model!: any;
  @Input() hasBinding!: boolean;
  @Input() dataSourceOptions!: any;
  @Input() alertMessages!: any;
  @Input() categoryFilterList!: any;
  @Input() variableCategoryFilter!: any;
  @Input() showDesignButton!: any;
  @Input() operationText!: string;
  @Input() treeData!: any;
  @Input() selectedNode!: any;
  @Input() selectedNodeProps!: any;
  @Input() validation!: any;
  @Input() showSpinner!: boolean;
  @Input() showServiceSpinner!: boolean;
  @Input() currentStep!: any;
  @Input() widgetList:any;
  @Output() setActiveDataSourceTab = new EventEmitter<any>();
  @Output() filterDataSource = new EventEmitter<any>();
  @Output() setVariableCategoryFilter = new EventEmitter<any>();
  @Output() selectedSourceOperations = new EventEmitter<any>();
  @Output() setOperationForSelectedSource = new EventEmitter<any>();
  @Output() onOperationClear = new EventEmitter<any>();
  @Output() enableNext = new EventEmitter<any>();
  @Output() handleTreeNodeClick = new EventEmitter<any>();
  @Output() updateBindMapTree = new EventEmitter<any>();
  @Output() onDynamicWidgetChange = new EventEmitter<any>();
  @Output() updateGeneratedVariableName = new EventEmitter<any>();
  private typeService = inject(TypeFactoryService);
  private pageWsService :PageWsService;

  dataSourceTabs: any = {
    'variable': { 'name': 'variables', 'active': true, 'hasBinding': false },
    'widget': { 'name': 'widgets', 'active': false, 'hasBinding': false },
    'existing': { 'name': 'existing', 'active': false, 'hasBinding': false }
  };
  bindVariableService:BindVariableService;
  baseVariableService: BaseVariableService


  activeDataSourceTab: any;
  disableBind: boolean;
  variableNameLimit: any;
  _widgetsAvailable:any;
  variableConstants = VARIABLE_CONSTANTS;

  @Input() set widgetsAvailable(val: any) {
   this._widgetsAvailable=val
  }
  get widgetsAvailable():any{
    return this._widgetsAvailable !== 0;
  }

  constructor(private router: Router,
              private wsManager: WmsWorkspaceManagerService, private embedDBService: EmbedDbService) {
    super();
    this.bindVariableService = inject(BindVariableService);
    this.pageWsService = inject(PageWsService);
    this.baseVariableService = inject(BaseVariableService);
  }
  setActiveTab(tab?: string) {
    this.setActiveDataSourceTab.emit(tab);
  }

  handleNodeClick(node: any) {
    this.handleTreeNodeClick.emit(node);
  }

  onServiceSelect(selectedService: any) {
      this.typeService.getDataTypesByService(selectedService.name, true).then((res: any) => {
        this.selectedSourceOperations.emit(selectedService);
      });
  }

  onOperationSelect(selectedOperation: any) {
    this.setOperationForSelectedSource.emit(selectedOperation);
    this.enableNext.emit()
  }

  updateBindMapTreeSelect(selectedWidget:any){
      let bindDataSet = selectedWidget.binddataset
      if (bindDataSet && bindDataSet.startsWith('bind:Variables')) {
        let variableName = bindDataSet.split('.')[1];
        this.getDataTypesByVariableName(variableName, selectedWidget);
      }
      if (bindDataSet && bindDataSet.startsWith('bind:Widgets')) {
        let widgetList = byType('form-widgets');
        let widgetName = bindDataSet.split('.')[1];
        let nextWidget = widgetList[widgetName];

        // Loop to process nested widgets
        while (nextWidget && nextWidget.binddataset.startsWith('bind:Widgets')) {
          widgetName = nextWidget.binddataset.split('.')[1];
          nextWidget = widgetList[widgetName];
        }

        // Process the final widget or variable
        if (nextWidget && nextWidget.binddataset.startsWith('bind:Variables')) {
          let variableName = nextWidget.binddataset.split('.')[1];
          this.getDataTypesByVariableName(variableName, selectedWidget);
        }
      }
  }

  getDataTypesByVariableName(variableName:any,selectedWidget:any){
    Object.values(this.baseVariableService.variableCollection).forEach((collection:any) => {
      const variable = collection[variableName];
      if(variable){
        let service = variable.liveSource ||variable.service;
        this.typeService.getDataTypesByService(service,true).then(()=>{
          this.updateBindMapTree.emit(selectedWidget)
        })
      }
    });
  }
  newService(type: string, $event?: any): void {
    this.eventManager.emitcloseDialogWithId('widgetConfigDialog');
    switch (type) {
      case 'DATABASE_CREATE':
      case 'DATABASE_IMPORT': {
        if (this.wsManager?.isWSDirty()) {
          // active ws should be saved before switching
          this.wsManager.saveActiveWs.next(() => this.goToDBWS(type));
          return;
        } else {
          this.goToDBWS(type);
        }
        break;
      }
      case 'WEB_SERVICE': {
        if (this.wsManager?.isWSDirty()) {
          // active ws should be saved before switching
          this.wsManager.saveActiveWs.next(() => this.goToAPIDesigner(type, $event));
          return;
        } else {
          this.goToAPIDesigner(type, $event);
        }
        break;
      }
      case 'JAVA_SERVICE' : {
        if (this.wsManager?.isWSDirty()) {
          // active ws should be saved before switching
          this.wsManager.saveActiveWs.next(() => this.goToJavaServiceWS(type));
          return;
        } else {
          this.goToJavaServiceWS(type);
        }
        break;
      }
      default:  break;
    }
  }

  goToDBWS(type: string): void {
    this.embedDBService.toOpenDialog = type;
    this.eventManager.emitSetActiveWSCategory('DB');
    this.router.navigate(['database']);
    if(type){
      setTimeout(() => {
         this.eventManager.emitopenDBCreateDialog(type);
      });
    }
  }

  goToJavaServiceWS(type: string): void {
    this.embedDBService.toOpenDialog = type;
    this.eventManager.emitSetActiveWSCategory('JAVASERVICE');
    this.router.navigate(['java-service']).then(()=> {
      if(type) {
        setTimeout(() => {
          this.eventManager.emitOpenJavaSerivceCreateDialog(type);
        });
      }
    });
  }

  goToAPIDesigner(type: string, $event: any): void {
    this.embedDBService.toOpenDialog = type;
    this.eventManager.emitSetActiveWSCategory('APIDESIGNER');
    this.router.navigate(['apis']).then(()=> {
      if(type){
        setTimeout(() => {
          this.eventManager.emitOpenAPIDesignerDialog({ type : type, $event : $event});
        });
      }
    });
  }

  getTypesByService($event:any){
    let service = $event.liveSource || $event.service
      this.typeService.getDataTypesByService(service, true).then((res: any) => {
        this.updateBindMapTree.emit($event);
      });
  }


  checkSelectedDataSourceMaxResult() {
    if(!this.selectedDataSource.maxResults) {
      this.selectedDataSource.maxResults = 20;
    }
  };
}
